module.exports = __webpack_public_path__ + "app/img/logo-widget.9da46a5a.svg";